import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#0075A2",
      light: "#99E2FF",
    },
    secondary: {
      main: "#FFC857",
    },
    warning: {
      main: "#DE6449",
    },
  },
});
